<template>
    <div class="scc-image-box">
        <div class="scc-image-box__left" :style="componentStyle">
            <div class="scc-image-box__left-container">
                <h2 v-if="title" class="scc-image-box-title">{{ title }}</h2>
                <SccLink v-if="buttonText" class="scc-image-box__button" :to="buttonLinkTo">
                    {{ buttonText }}
                </SccLink>
            </div>
        </div>
        <div class="scc-image-box__right">
            <div class="scc-image-box__right-container">
                <h3 v-if="subtitle" class="scc-image-box-title">{{ subtitle }}</h3>
                <p v-if="text" class="scc-image-box__text">{{ text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import './image-box.scss';
import SccLink from './SccLink';

export default {
    name: 'ImageBox',
    components: { SccLink },
    __editor: {
        fields: {
            image: {
                widget: 'media',
            },
        },
    },
    props: {
        image: {
            type: String,
            default: 'http://www.placehold.it/400x400',
        },
        title: {
            type: String,
            default: 'Maak kans op mooi prijzen',
        },
        subtitle: {
            type: String,
            default: 'Doe mee en maak kans!',
        },
        text: {
            type: String,
            default:
                'Ut pulvinar lectus ex. Nam elit lectus, auctor vitae ex et, ullamcorper laoreet ligula. Cras viverra est at risus sagittis placerat. Vivamus mollis quam et placerat luctus. Donec justo nibh, fermentum at placerat sit amet, volutpat eget velit. Maecenas fringilla aliquet mauris eget consequat. Aliquam',
        },
        buttonText: {
            type: String,
            default: 'Bekijk alle prijzen',
        },
        buttonLinkTo: {
            type: String,
            default: 'prijzen',
        },
    },
    computed: {
        componentStyle() {
            return this.image ? `background-image: url(${this.image})` : null;
        },
    },
};
</script>
